import type { FaireProductEntity } from "../../entity_types/product";

export const p_wuse5vsqch: FaireProductEntity = {
  token: "p_wuse5vsqch",
  type: "product",
  name: "MB FASHION Cropped Zip-Up Hoodie & High-Waist Leggings Set 5089",
  brandToken: "b_e85zy9a2fg",
  brandName: "MB Fashion Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/501aaad70e61f5dae61aa1e677f7ae8ac780d675c2d0d9b653379657258b7db6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc864390afd587542819ff2fd585cab64b0253002122ec7f1f2201ac21778278.jpeg",
    "https://cdn.faire.com/fastly/3912c1bba564b7d2189e3f9a0af7d311e1c09b0cc27e4765f6dea8a4c9b8a758.jpeg",
    "https://cdn.faire.com/fastly/46c66cb6f394abbc455cc4b6580bb9b0014e971174ee716abc47ff6bf14d6bc6.jpeg",
    "https://cdn.faire.com/fastly/b9bd9a634be9a6ce4ccfd44fe239c6dbd7cf12bfeb8a5a0c5d345146c19792ac.jpeg",
    "https://cdn.faire.com/fastly/556bfaff7df1f1685144bc1ec67ee966cf3fc7144f202b424f1abef577aa88b5.jpeg",
    "https://cdn.faire.com/fastly/6a1246edb0e2a9f0f453b4040e3a4293a9a01a629b1216e2165aaddec89b2d86.jpeg",
    "https://cdn.faire.com/fastly/946a8037b4cddf026d613235be193230c214cc1648d969c9a32acc6a1150d6fb.jpeg",
    "https://cdn.faire.com/fastly/7dd4de67da8a87f68a164a09efaa01f64b4c57a59a2d26fce55b3f13df5df858.jpeg",
    "https://cdn.faire.com/fastly/f5027a18ef9c173929ec387bc55c336566de9d29447a9519224bb0f6359e26d2.jpeg",
    "https://cdn.faire.com/fastly/ba3a3608b78718e313c816817ae628937dec00be1efd997e64b78b55244cb63f.jpeg",
    "https://cdn.faire.com/fastly/9252fce5d94ecbaa0585b2a5ee32381de82c4f3e9cb8d1967b8c27320c203e61.jpeg",
    "https://cdn.faire.com/fastly/633cb0b173013319a8a978755f7d3e6a3fe45a8c7f2a3b9881371700b698e80a.jpeg",
    "https://cdn.faire.com/fastly/0532ee8209c6b399b1b85f112b624602da97f4e128080519f1634c9bf8486f93.jpeg",
    "https://cdn.faire.com/fastly/cb3bcd19578745fe53c5326dbc81605052400026d7138392f92a60d33d1b5b90.jpeg",
    "https://cdn.faire.com/fastly/8ec7d5d77a034f19165b410712d53f79a79d0740461729d3af8700a7621ba8c2.jpeg",
    "https://cdn.faire.com/fastly/6d1147cb5e5dd56655e23a0bcf247edaf621ced53adad572cdc7d9e1dd71ce61.jpeg",
    "https://cdn.faire.com/fastly/cc8b738f122eaeda79b812fd421d1edf73525d9ad92deb1977d681d882873724.jpeg",
    "https://cdn.faire.com/fastly/0e89e0c35cc89d8c626cb3572a2d73581a6d1b2576b03068acdbe4a84c832022.jpeg",
  ],
  priceDollars: 35,
  description:
    "Stay comfy and stylish in this casual two-piece lounge set designed for everyday wear. The outfit includes a cropped zip-up hoodie paired with matching high-waist leggings, offering a flattering, form-fitting silhouette perfect for both relaxing and running errands.\n\n\n\nThe hoodie features a full front zipper, drawstring hood, ribbed cuffs, and a soft, lived-in finish for a relaxed look. The coordinating leggings are made with a stretchy, body-hugging fabric that smooths and shapes while keeping you comfortable all day.\n\n\n\nWhether you’re heading out in sneakers or lounging at home, this set delivers effortless style and comfort in one.\n\n\n\nDetails:\n\n\n\n * Two-piece set: cropped zip-up hoodie + high-waist leggings \n * Full-zip hoodie with drawstring hood and ribbed cuffs \n * Soft, comfortable fabric with a casual, relaxed finish \n * Stretchy, body-contouring leggings \n * Perfect for errands, casual wear, or athleisure looks \n\n",
  tags: [],
  msrpDollars: 70,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:05.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
